module.exports = __webpack_public_path__ + "media/images/lp/industries/issue_salon-21161270fb698df585ba36da7129d64d.svg";